import React, { useState } from "react";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import { feelingSickReducer, mapDispatchToProps } from "./FeelingSick.store";
import AddFeelingSick from "../../library/AddFeelingSick/AddFeelingSick";
import CustomModal from "../../ui-library/CustomModal/CustomModal";
import ButtonDropdown from "../../ui-library/ButtonDropdown/ButtonDropdown";
import { useTranslation } from "react-i18next";
import { isRtl } from "../../../i18n/helpers";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";

export const SmartFeelingSick = (props) => {
  const {
    addOrUpdateFeelingSick,
    removeFeelingSick,
    sickDayDate,
    dailyItemKey,
    refreshData,
    isSickDay,
    date,
  } = props;

  const [showFeelingSickModal, setShowFeelingSickModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const { t } = useTranslation();

  const feelingSickOptions = {
    ADD: {
      id: "add",
      text: t("appText.add"),
      type: "add",
      isDisabled: isSickDay,
      isVisible: true,
      onClick: () => openAddFeelingSick(),
    },
    EDIT: {
      id: "edit",
      text: t("appText.edit"),
      type: "edit",
      isDisabled: !isSickDay,
      isVisible: true,
      onClick: () => openAddFeelingSick(),
    },
    REMOVE: {
      id: "remove",
      text: t("appText.remove"),
      type: "remove",
      isDisabled: !isSickDay,
      isVisible: true,
      onClick: () => onRemoveFeelingSick(),
    },
  };

  const closeAddFeelingSick = () => {
    setShowFeelingSickModal(false);
  };

  const openAddFeelingSick = () => {
    setShowFeelingSickModal(true);
  };

  const onSubmitFeelingSick = (formData) => {
    setSubmitting(true);

    addOrUpdateFeelingSick(formData, isSickDay)
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        closeAddFeelingSick();
        refreshData();
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onRemoveFeelingSick = () => {
    removeFeelingSick({
      isSick: false,
      sickDayDate: sickDayDate,
      reasonForChange: "",
    })
      .then((message) => {
        sendNotification(message, ToastType.SUCCESS);
        closeAddFeelingSick();
        refreshData();
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
      });
  };

  return (
    <>
      <CustomModal
        show={showFeelingSickModal}
        title={t("appText.notFeelingWell.title")}
        onClose={closeAddFeelingSick}
      >
        <AddFeelingSick
          onClose={closeAddFeelingSick}
          date={date}
          sickDayDate={sickDayDate}
          onSubmit={onSubmitFeelingSick}
          submitting={submitting}
        />
      </CustomModal>
      <ButtonDropdown
        dataTestId={`feeling-sick-${dailyItemKey}`}
        size="sm"
        title={t("appText.dietDiary.feelingSick")}
        checked={isSickDay}
        options={Object.values(feelingSickOptions)}
        align={isRtl() ? "end" : "start"}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return { ...state };
};

export default dynamic(
  "feelingSickReducer",
  subspaced({
    mapExtraState: (state, rootState) => ({
      loginReducer: { ...state.loginReducer },
      smartPageHeaderReducer: { ...state.smartPageHeaderReducer },
    }),
  }),
  attachReducer(feelingSickReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartFeelingSick));
